import { useMediaQuery } from '@mui/material'
import theme from '../theme'

export default function useRwd() {
  const isPC = useMediaQuery(theme.breakpoints.up('lg'))
  const isToplet = useMediaQuery(theme.breakpoints.between('sm', 'lg'))
  const isPhone = useMediaQuery(theme.breakpoints.down('sm'))

  return { isPC, isToplet, isPhone }
}
